import * as formik from 'formik';
import * as fabric from 'office-ui-fabric-react';
import { FC, useState } from 'react';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import * as api from '../../../../../../api/generated';
import { ILocationItem } from '../../../../../../components/custom/LocationTree';
import KendoLoading from '../../../../../../components/spinners/KendoLoading';
import { IWindowComponentProps } from '../../../../../../components/windows/WindowContext';

interface LocationConfigDoorScreenLocationsCreateWindowProps {
    fetchData: () => Promise<void>;
    unselectedLocations: ILocationItem[];
    doorScreenId: number;
}

interface IDoorScreenLocationDisplayItem {
    locationId: number | null;
    doorScreenId: number | null;
}

const validationSchema = Yup.object<IDoorScreenLocationDisplayItem>().shape({
    locationId: Yup.number().required('Šis laukas yra privalomas')
});

const LocationConfigDoorScreenLocationsCreateWindow: FC<IWindowComponentProps<LocationConfigDoorScreenLocationsCreateWindowProps>> = (props) => {
    const {
        componentProps: { unselectedLocations, fetchData, doorScreenId },
        onClose
    } = props;

    const initialState: IDoorScreenLocationDisplayItem = {
        locationId: null,
        doorScreenId: doorScreenId
    };

    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (values: IDoorScreenLocationDisplayItem, formikActions: formik.FormikHelpers<IDoorScreenLocationDisplayItem>) => {
        setIsLoading(true);
        try {
            await api.administration.createDoorScreenDisplayLocation({ ...values, doorScreenId: doorScreenId });

            toast.success('Atvaizduojama lokacija info ekranui priskirta sėkmingai');
        } catch (ex) {
            toast.error(ex.error[0]);
        } finally {
            setIsLoading(false);
            await fetchData();
            onClose();
        }
    };

    const mapLocationsOptions = (unselectedLocations: ILocationItem[]): fabric.IDropdownOption[] => {
        const options: fabric.IDropdownOption[] = [];
        unselectedLocations.map((x) => {
            options.push({ key: x.id.toString(), text: x.name ? x.name : '' });
        });
        return options;
    };

    return (
        <>
            {isLoading ? (
                <KendoLoading />
            ) : (
                <>
                    <formik.Formik validationSchema={validationSchema} initialValues={initialState} onSubmit={handleSubmit}>
                        {(formikProps) => (
                            <formik.Form>
                                <div className="ms-Grid-row">
                                    <formik.Field name="locationId">
                                        {({ field, form }: formik.FieldProps<number | null>) => (
                                            <fabric.Dropdown
                                                selectedKey={field.value}
                                                {...field}
                                                label="Lokacija"
                                                options={mapLocationsOptions(unselectedLocations)}
                                                placeholder="Pasirinkite lokaciją"
                                                onChange={({}, option?: fabric.IDropdownOption) =>
                                                    option && form.setFieldValue(field.name, option.key)
                                                }
                                                errorMessage={
                                                    (formikProps.status && formikProps.status.locationId) ||
                                                    (form.errors.locationId && form.errors.locationId)
                                                }
                                            />
                                        )}
                                    </formik.Field>
                                </div>
                                <div style={{ textAlign: 'center', marginTop: '30px' }}>
                                    <fabric.PrimaryButton
                                        className="ms-slideRightIn40 ms-textAlignRight"
                                        text="Išsaugoti"
                                        disabled={formikProps.isSubmitting || !formikProps.isValid || !formikProps.dirty}
                                        type="submit"
                                    />
                                </div>
                            </formik.Form>
                        )}
                    </formik.Formik>
                </>
            )}
        </>
    );
};

export default LocationConfigDoorScreenLocationsCreateWindow;
